import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
import { Apollo } from 'apollo-angular';
import { ToastService } from 'src/app/core/toast.service';
import { combineLatest } from 'rxjs';
import { Filter } from 'src/app/core/models/filter';
import { GET_REGISTERED_COUNT, getAllCoursedata, getRelatedCourse, getSelectedCourse } from '../queries/learning-hub.query';

@Injectable({
  providedIn: 'root',
})

export class LearningHubService {
  constructor(private apollo: Apollo, private toast: ToastService) { }



  getCourseByid(id: string, userId: string) {
    return this.apollo.use('external').watchQuery({
      query: getSelectedCourse,
      variables: { id, userId },
      fetchPolicy: 'network-only'
    }).valueChanges.pipe(pluck('data', 'courses_by_pk'));
  }




  // limit data 
  getAllRelatedCourse(limit: number, offset: number, type?: string, status?: string, active_status?: string, id?: string) {

    const where: any = {
      _and: [
        { type: { _eq: type } },
        { active_status: { _eq: active_status } },
        { status: { _eq: status } },
        { id: { _neq: id } }, // Exclude the course with matching ID
      ],
    };

    return this.apollo.use("external").watchQuery({
      query: getRelatedCourse,
      variables: {
        limit,
        offset,
        where
      },
      fetchPolicy: 'cache-and-network'
    }).valueChanges.pipe(pluck('data', 'courses'));
  }



  getAllLearningHubData(
    limit: number,
    offset: number,
    search?: string,
    extraFilters?: {
      type?: string[];
      categoryIds?: string[];
      start_date?: string | null;
      address?: string
    }
  ): Observable<any[]> {

    const where: Record<string, any> = {};

    // Search filter
    const trimmedSearch = search?.trim();
    if (trimmedSearch) {
      where._or = [
        { company_name: { _ilike: `%${trimmedSearch}%` } },
        { course_name: { _ilike: `%${trimmedSearch}%` } },
        { presented_by_name: { _ilike: `%${trimmedSearch}%` } }
      ];
    }

    // Type filter
    if (extraFilters?.type?.length) {
      where.type = { _in: extraFilters.type };
    }

    // Category filter
    if (extraFilters?.categoryIds?.length) {
      where.course_category_id = { _in: extraFilters.categoryIds };
    }

    // Start date filter
    if (extraFilters?.start_date) {
      where.startDate = { _eq: extraFilters.start_date };
    }

    // Address filter
    const trimmedAddress = extraFilters?.address?.trim();
    if (trimmedAddress) {
      where.address = {
        _cast: { String: { _ilike: `%${trimmedAddress}%` } }
      };
    }

    return this.apollo.use("external").query({
      query: getAllCoursedata,
      variables: { limit, offset, where },
    }).pipe(pluck('data', 'courses'));
  }



  getRegisteredCount(courseId: string) {
    return this.apollo.use('external').watchQuery({
      query: GET_REGISTERED_COUNT,
      variables: { courseId },
      fetchPolicy: 'network-only',
    }).valueChanges.pipe(
      pluck('data', 'course_registered_users_aggregate', 'aggregate', 'count')
    );
  }

}